import CaseDetail from "./"
import { useParams } from "react-router-dom"
import { compose, withProps } from "recompose"
import moment from "moment"
import { graphql } from "@apollo/client/react/hoc"
import { CASE_DETAIL_QUERY } from "../../apollo/queries"

const CaseDetailEnhanced = compose(
  withProps(() => {
    const { facilityId, caseId } = useParams()
    return {
      facilityId,
      caseId,
    }
  }),
  graphql(CASE_DETAIL_QUERY, {
    options: ({ facilityId, caseId }) => ({
      variables: { facilityId, caseId },
    }),
    props: ({ data: { error, loading, facility } }) => {
      if (error) throw error

      if (loading) return {}

      if (facility.contactTracingCases.length === 0) throw Error("404")

      const subjects = facility.contactTracingCases[0].subjects

      return {
        caseStartAt: moment
          .min(subjects.map((subject) => moment.parseZone(subject.startAt)))
          .format(),
        caseEndAt: moment
          .max(subjects.map((subject) => moment.parseZone(subject.endAt)))
          .format(),
        type: facility.contactTracingCases[0].type,
      }
    },
  })
)(CaseDetail)

export default CaseDetailEnhanced
